
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/sharing-the-spark-a-guide-to-presenting-curipod-with-confidence",
      function () {
        return require("private-next-pages/c/blog-posts/sharing-the-spark-a-guide-to-presenting-curipod-with-confidence.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/sharing-the-spark-a-guide-to-presenting-curipod-with-confidence"])
      });
    }
  